












import { TranslateResult }                      from 'vue-i18n';
import { computed, defineComponent, onMounted } from '@vue/composition-api';
import { Computed }                             from '@/types';
import { View }                                 from '@/views/users/users.types';
import { useGlobals }                           from '@/hooks/use-globals';
import { useUser }                              from '@/views/users/hooks/use-user';
import cBreadcrumb                              from '@/components/breadcrumb/breadcrumb.component.vue';
import cUsersHeader                             from '@/views/users/components/users-header.component.vue';
import cAddUserSidePanel                        from '@/views/users/components/users-side-panel.component.vue';
import cUsersListGrid                           from '@/views/users/components/view-mode/grid/users-list-grid.component.vue';
import cUsersListTable                          from '@/views/users/components/view-mode/table/users-list-table.component.vue';

export default defineComponent({
  name: 'vUsers',
  components: {
    cUsersHeader,
    cBreadcrumb,
    cAddUserSidePanel,
    cUsersListGrid,
    cUsersListTable,
  },
  setup() {
    const { i18n, store } = useGlobals();
    const { getUsers } = useUser();
    const getBreadcrumbTranslation: Computed<TranslateResult> = computed(() => i18n.t('vUsers.meta.breadcrumb'));
    const isModalOpen: Computed<boolean> = computed((): boolean => store.state.views.vUsers.modal?.open);
    const viewMode: Computed<View> = computed((): View => store.state.views.vUsers.view);

    onMounted(() => {
      getUsers();
    });

    return {
      getBreadcrumbTranslation,
      isModalOpen,
      viewMode,
      View,
    };
  },
});
